import { GlobalHandler } from "./components/TokatsuSystem.js?v=1.0.3";
import { topCarousel, announceCarousel } from "./components/Carousels.js?v=1.0.5";
import { submenuToggle } from "./components/Accordion.js?v=1.0.1";
import { HeaderGlobalMenu } from "./components/HeaderGlobalMenu.js?v=1.0.1";
import { HeaderH1 } from "./components/Header.js?v=1.0.1";
import { initAOS } from "./initAos.js?v=1.0.1";
import { setupScrollLinks } from "./components/scrollToElement.js?v=1.0.2";
import { fadeInTransition, handleBackNavigation } from "./components/Transition.js";
import { Plan, setButton } from "./components/Plan.js";
import { TargetPrint } from "./components/TargetPrint.js"
import { Facility } from "./components/Facility.js"

window.addEventListener('popstate', function(event) {
  handleBackNavigation();
});

/**---------------------------------------------
 * e.persisted…pageshow イベントオブジェクト（e）のプロパティ。
 * ページがブラウザのキャッシュから復元されたかどうか（true/false）
**-----------------------------------------------*/
window.addEventListener('pageshow', function(e) {
  document.querySelector(`[name="FNP_CD"]`) &&
    e.persisted &&
    setTimeout(setButton, 500);
});

window.addEventListener('DOMContentLoaded', async function () {
  // プランの印刷用ページかどうかを判別
  const isTargetPrint = document.body.id === 'targetPrint';
  // プランの印刷用ページ専用の初期化
  const initTargetPrint = async () => {
    await TargetPrint.init();
  };
  // 通常WPページの初期化
  const initDefault = async () => {
    // blockThirdPartyCookies();
    await GlobalHandler.init();
    HeaderGlobalMenu();
    submenuToggle();
    HeaderH1();
    fadeInTransition();
    await topCarousel();//トップページ限定
    announceCarousel({ autoSlide: true, autoSlideDelay: 5000 });//トップページ限定
    await initAOS();
    await Plan.init();//プランページ限定
    await Facility.init();//式場ページ限定
    const navHeight = document.getElementById(`gh_nav`).offsetHeight;
    const offset = navHeight ? navHeight / 2 : 0;// スクロール位置を調整するオフセット値（ピクセル単位）
    setupScrollLinks(offset);
  };

  const initFn = isTargetPrint ? initTargetPrint : initDefault;
  await initFn();
});

